import { Component, OnInit } from "@angular/core";
import { ProductService } from "src/app/core/services/product.service";
import { ActivatedRoute } from "@angular/router";
import { error } from "protractor";
import { environment } from "src/environments/environment";



@Component({
  selector: "app-product-list",
  templateUrl: "./product-list.component.html",
  styleUrls: ["./product-list.component.css"],
})
export class ProductListComponent implements OnInit {
  public productList: any[];
  public urlHost = "";
  public loading: boolean = true;
  constructor(
    private productService: ProductService,
    private router: ActivatedRoute
  ) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    const codCategoria = this.router.snapshot.params.id;
    this.getProductList(codCategoria);
  }

  getProductList(codCategoria) {
    this.loading = true;
    this.productService.getProductList(codCategoria).subscribe(
      (data) => {
        this.productList = data;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  getValidate(product:any):boolean{
    return this.productService.getValidate(product);
  }
  
}
